import React from 'react';
import { connect } from 'react-redux';

import {
  Heading,
  Flex,
  Button,
  Text,
  theme,
} from '@frontend/legacy-components';

import { SupportDrawer } from 'components/support';

import { getUser } from 'store/session/selectors';

import { ChakraProvider } from 'utils/ChakraProvider';

const connector = connect((state) => ({
  user: getUser(state),
}));

class ErrorBoundaryUnconnected extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, isSupportDrawerOpen: false };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  setIsSupportDrawerOpen(isOpen) {
    this.setState({ isSupportDrawerOpen: isOpen });
  }

  componentDidCatch(error) {
    const { user } = this.props;
    if (user) {
      //Logging user information in error because datadog intercepts error message
      console.error(
        `${user.first_name} ${user.last_name} (email: ${user.email}) from ${user.group.name} encountered the Oops screen with the following error: ${error}`,
      );
    } else {
      console.error(error);
    }
  }
  handleBack = () => {
    if (window.history.length > 2) {
      window.history.back();
    } else {
      window.location.href = '/';
    }
  };

  render() {
    const { showBackButton = false, renderError, children } = this.props;
    const { error, isSupportDrawerOpen } = this.state;

    if (error) {
      if (renderError) {
        return renderError(error);
      } else {
        return (
          <ChakraProvider theme={theme}>
            <Flex
              mx={4}
              my={20}
              role="alert"
              flexDirection="column"
              alignItems="center"
            >
              <Heading size="2xl" as="h1">
                Something went wrong
              </Heading>
              <Text mt={1}>
                To troubleshoot, try reloading once, then{' '}
                <Button
                  variant="link"
                  onClick={() => this.setIsSupportDrawerOpen(true)}
                >
                  contact support
                </Button>
                .
              </Text>
              {showBackButton && (
                <Button mt={2} variant="secondary" onClick={this.handleBack}>
                  Return to previous page
                </Button>
              )}
            </Flex>
            <SupportDrawer
              isOpen={isSupportDrawerOpen}
              onClose={() => this.setIsSupportDrawerOpen(false)}
            />
          </ChakraProvider>
        );
      }
    }
    return children;
  }
}

export const ErrorBoundary = connector(ErrorBoundaryUnconnected);
